import lodash from "lodash";
import { useSelector, useDispatch } from "react-redux";
import { financeManagerAllSelector } from "store/bailiff/finance/manager/finance_manager.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
export const useDataFinance = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const finance = useSelector(financeManagerAllSelector);
  const data = lodash.orderBy(finance, "setAt", "desc") || [];

  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { data };
};
